<template>
  <ODialog ref="dialog" :maxWidth="700">
    <v-card>
      <ODialogBar
        title="Baixar Rawdata de Heartbeats"
        @close="$refs.dialog.$dismiss()"
      />
      <v-card-text class="pa-6 scroll-y">
        <OCol>
          <div>
            <v-text-field
              label="A partir do HB (obrigatório)"
              v-model="fromHbId"
              :disabled="loadingFrom"
              @change="loadFrom"
            />
            <OLoadingLine absolute :value="loadingFrom" />
            <SingleHeartbeat :value="fromHb" />
          </div>
          <div class="mt-8">
            <v-text-field
              label="Até o HB (opcional)"
              v-model="untilHbId"
              :disabled="loadingUntil"
              @change="loadUntil"
            />

            <OLoadingLine absolute :value="loadingUntil" />
            <SingleHeartbeat :value="untilHb" />
          </div>
        </OCol>
      </v-card-text>
      <v-card-actions class="pa-6">
        <v-btn text large @click="$refs.dialog.$dismiss()">
          Cancelar
        </v-btn>
        <v-spacer />
        <v-btn text large color="primary" @click="doExport">
          <v-icon>mdi-download</v-icon>
          Baixar
        </v-btn>
      </v-card-actions>
    </v-card>
  </ODialog>
</template>

<script>
import { go } from '@/models'
import SingleHeartbeat from './SingleHeartbeat.vue'

export default {
  components: { SingleHeartbeat },
  data() {
    return {
      loadingFrom: false,
      fromHb: null,
      loadingUntil: false,
      untilHb: null,
      clientId: null,
      fromHbId: null,
      untilHbId: null
    }
  },
  methods: {
    open() {
      return this.$refs.dialog.$open()
    },

    isValidId(x) {
      return x != null && x.toString().match(/^[0-9]+$/)
    },

    async loadFrom() {
      try {
        if (!this.isValidId(this.fromHbId)) return null
        this.loadingFrom = true
        this.fromHb = await go.get('/heartbeats/' + this.fromHbId)
        this.clientId = this.fromHb.clientId
      } catch (err) {
        this.$showErr(err)
      } finally {
        this.loadingFrom = false
      }
    },

    async loadUntil() {
      try {
        if (!this.isValidId(this.untilHbId)) return null
        this.loadingUntil = true
        this.untilHb = await go.get('/heartbeats/' + this.untilHbId)
      } catch (err) {
        this.$showErr(err)
      } finally {
        this.loadingUntil = false
      }
    },

    async doExport() {
      const ps = {
        fromHbId: this.fromHbId,
        untilHbId: this.untilHbId
      }

      const { blob } = await go.download(`hb-export/${this.clientId}`, ps)
      const str = await blob.text()
      this.$refs.dialog.$apply(str)
    },

    doInspect() {
      const { clientId, fromHbId, untilHbId } = this
      const qs = go.toQueryString({ clientId, fromHbId, untilHbId })
      window.open('/#/rawdata/inspector?' + qs)
    }
  }
}
</script>

<style lang="sass"></style>
